import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=67a113ea&scoped=true"
import script from "./Docs.vue?vue&type=script&lang=ts"
export * from "./Docs.vue?vue&type=script&lang=ts"
import style0 from "./Docs.vue?vue&type=style&index=0&id=67a113ea&prod&scoped=true&lang=css"
import style1 from "./Docs.vue?vue&type=style&index=1&id=67a113ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a113ea",
  null
  
)

export default component.exports